import type { SxProps, Theme } from '@mui/material/styles';
import { tokensDark } from '../../../theme/themeSettings';
import { reportsToolbarSurfaceBg } from './reportsToolbarSurface';

/** Sticky sortable table header background — theme-aware (incl. PROFESSIONAL). */
export function getInfralytiqsReportTableHeaderBg(theme: Theme): string {
  const dash = theme.palette.dashboard;
  if (dash?.reportTableHeaderBackgroundColor) {
    return dash.reportTableHeaderBackgroundColor;
  }
  // DEFAULT LIGHT: same surface as ReportPanel title bar (reportsToolbarSurfaceBg)
  return theme.palette.mode === 'dark'
    ? tokensDark.primary[700]
    : reportsToolbarSurfaceBg(theme);
}

/** Sticky sortable table header label color. */
export function getInfralytiqsReportTableHeaderTextColor(theme: Theme): string {
  const dash = theme.palette.dashboard;
  if (dash?.reportTableHeaderTextColor) {
    return dash.reportTableHeaderTextColor;
  }
  return theme.palette.mode === 'dark'
    ? tokensDark.secondary[100]
    : '#000000';
}

/** Shared `TableCell` sx for sortable report table header cells. */
export function getInfralytiqsReportTableHeaderCellSx(
  theme: Theme,
  extra?: SxProps<Theme>,
): SxProps<Theme> {
  const headerColor = getInfralytiqsReportTableHeaderTextColor(theme);
  return {
    fontWeight: 600,
    bgcolor: getInfralytiqsReportTableHeaderBg(theme),
    color: headerColor,
    '& .MuiTableSortLabel-root': {
      color: headerColor,
    },
    '& .MuiTableSortLabel-root:hover': {
      color: headerColor,
    },
    '& .MuiTableSortLabel-root.Mui-active': {
      color: headerColor,
    },
    '& .MuiTableSortLabel-icon': {
      color: `${headerColor} !important`,
    },
    ...extra,
  };
}
